// extracted by mini-css-extract-plugin
export var columns = "Decklist-module--columns--7e174";
export var container = "Decklist-module--container--ffecf";
export var divider = "Decklist-module--divider--6c22a";
export var heading = "Decklist-module--heading--841d2";
export var withSideboard = "Decklist-module--withSideboard--67f95";